export enum PostFormAllowSignature {
    Disallowed,
    Permission,
    Approval,
    Verification
}

export namespace PostFormAllowSignature {

    export function disclaimerValues(): PostFormAllowSignature[] {
        return [
            PostFormAllowSignature.Permission,
            PostFormAllowSignature.Approval,
            PostFormAllowSignature.Verification
        ];
    }

    export function getReviewLabel(allowSignature: PostFormAllowSignature): string {
        switch (allowSignature) {
            case PostFormAllowSignature.Disallowed:
                return '';
            case PostFormAllowSignature.Permission:
                return 'Permission Disclosure';
            case PostFormAllowSignature.Approval:
                return 'Approval Disclosure';
            case PostFormAllowSignature.Verification:
                return 'Verification Disclosure';
            default:
                return '';
        }
    }

    export function getDisclaimerLabel(allowSignature: PostFormAllowSignature): string {
        switch (allowSignature) {
            case PostFormAllowSignature.Disallowed:
                return '';
            case PostFormAllowSignature.Permission:
                return 'For giving permission to child, e.g., Field trip form';    
            case PostFormAllowSignature.Approval:
                return 'For indicating approval/aggrement, e.g., Media release form';
            case PostFormAllowSignature.Verification:   
                return 'For verification, e.g., Residency form';
            default:
                return '';
        }
    }

    export function getDisclaimerText(allowSignature: PostFormAllowSignature): string {
        switch (allowSignature) {
            case PostFormAllowSignature.Disallowed:
                return '';
            case PostFormAllowSignature.Permission:
                return `By clicking the 'I Approve' button below, I give my permission for my child to participate in the above mentioned activity.\n\nBy clicking the 'I Do Not Approve' button below, I deny permission for my child to participate in the above mentioned activity.`;
            case PostFormAllowSignature.Approval:
                return `By clicking the 'I Approve' button below, I understand and agree to follow the terms and conditions described above.\n\nBy clicking the 'I Do Not Approve' button below, I assert that I DO NOT AGREE with the terms and conditions described above.`;
            case PostFormAllowSignature.Verification:
                return `By clicking the 'Submit' button below, I declare that the information I have provided is true.`;
            default:
                return '';
        }
    }
}